import {Component} from 'react';

import AccessSection from "./access-section"
import Checkbox from '../checkbox';

export default class AccessPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            checkboxes: this.props.checkboxes,
        }
    }

    componentDidMount() {
    }

    getItemByType(item) {
        let type = null;

        switch (item.type) {
            case "text":
                type = <p>{item.value}</p>
                break;
        }

        return type;
    }

    render() {
        const { grant } = this.props;

        return (
            <div className="access-page">
                {this.props.data.map(({title, description, items}) => {
                    const checkboxes = items.filter(i => i.type == 'checkbox');
                    const files = items.filter(i => i.type == 'file');

                    const others = items.filter(i => i.type !== 'checkbox' && i.type !== 'file');

                    return (
                        <AccessSection title={title} subtitle={description}>
                            {others.map(item => item?.value && <div className="access-section-item" dangerouslySetInnerHTML={{ __html: item.value }}></div>)}

                            { checkboxes.length > 0 &&
                                <div className="utils__row utils__row--wrap utils__gap--20">
                                    { checkboxes.map(item => {
                                        if (!this.props.doesCheckboxExist(item)) return;

                                        item = this.props.checkboxes.find(i => i.questionTitle == item.questionTitle && i.label == item.label);

                                        return (
                                            <div className="access-section-item">
                                                <Checkbox text={item.value}
                                                        required={item.required}
                                                        error={!this.props.isCheckboxToggled(item) && item.error}
                                                        checked={this.props.isCheckboxToggled(item)}
                                                        onChange={(e) => this.props.onCheckboxClicked(item, e)}/>
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                            { files.length > 0 &&
                                <div className="utils__row utils__gap--20">
                                    {files.map(item => {
                                        return (
                                            <div className="document-file">
                                                <a target={'_blank'} rel={'noreferrer'}
                                                href={`/myeb/grants/${grant.id}/file/${item.name}`}
                                                className="document-file__icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36"
                                                        viewBox="0 0 36 36">
                                                        <path id="Path_128" data-name="Path 128"
                                                            d="M37,39H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H37a2,2,0,0,1,2,2V37A2,2,0,0,1,37,39ZM13,11v4H29V11Zm0,8v4H29V19Zm0,8v4H23V27Z"
                                                            transform="translate(-3 -3)" fill="#1577ea"/>
                                                    </svg>
                                                    <a className="document-file__view-overlay">
                                                        <svg id="Group_449" data-name="Group 449"
                                                            xmlns="http://www.w3.org/2000/svg" width="37.297"
                                                            height="37.297" viewBox="0 0 37.297 37.297">
                                                            <path id="Path_141" data-name="Path 141" d="M0,0H37.3V37.3H0Z"
                                                                fill="none"/>
                                                            <path id="Path_142" data-name="Path 142"
                                                                d="M1.181,16.986a17.1,17.1,0,0,1,33.627,0,17.1,17.1,0,0,1-33.627,0Zm16.813,7.77a7.77,7.77,0,1,0-7.77-7.77A7.77,7.77,0,0,0,17.994,24.757Zm0-3.108a4.662,4.662,0,1,1,4.662-4.662A4.662,4.662,0,0,1,17.994,21.649Z"
                                                                transform="translate(0.654 1.662)" fill="#fff"/>
                                                        </svg>

                                                    </a>
                                                </a>
                                                <p className="document-file__name">{item.name}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                        </AccessSection>
                    )
                })}
            </div>
        )
    }
}
